var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticStyle:{"height":"10vh"},attrs:{"src":_vm.image}})}
var staticRenderFns = []

export { render, staticRenderFns }